import { InstanceScreen } from 'component/navigation/instance';

export default function RankingEvalConversationSetScreen() {
    return <InstanceScreen screenKey='conversation-set' />;
}
